import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, ControlLabel, FormGroup, Row } from 'react-bootstrap';
import { actions, Control, Errors, Form } from 'react-redux-form';
import RangeSlider from '../../common/form/range-slider';
import Select from '../../common/form/dropdown';
import { updateOutletRest } from '../../../actions/outlet';
import ArrowButton from '../../common/button-arrow';
import DeliveryAddressPartial from '../../delivery-address/delivery-address-partial';

const OUTLET_MODEL = "deep.admin_outlet_view";

class OutletRewardDetails extends Component {
  handleTypeChange = (event) => {
    this.setState({
      voucher_denominations: event ? this.mapDenominations(this.props.nominations[event.value]) : [],
      selected_denomination: null,
      selected_type: event,
      changed: true,
    });

    this.props.dispatch(actions.change("deep.admin_outlet_view.voucher_denomination_id", ''));
  };

  handleSubmit = (values) => {
    this.props.dispatch(actions.submitFields("deep.admin_outlet_view", updateOutletRest(this.props.id, values, this.props.dispatch)));
  };

  constructor(props) {
    super(props);
    this.state = {
      slider: 100,
      autoRedeem: this.props.reward['auto-redeem'],
      voucher_denominations: [],
      selected_type: props.selectedType,
      selected_denomination: props.selectedDenomination,
      changed: false,
    }
  }

  componentWillReceiveProps(props) {
    if(!this.state.changed) {
      this.setState({
        selected_denomination: props.selectedDenomination,
        selected_type: props.selectedType,
        changed: true,
      });
    }
  }

  componentWillMount() {
    const { dispatch, reward, voucher, nominations } = this.props;

    dispatch(actions.load("deep.admin_outlet_view.reward_markup", 100 - reward['reward-markup']));

    let selectedVoucher = { attributes: {} },
      selectedDenomination = {},
      availableDenominations = [];

    if (reward['voucher-type']) {
      selectedVoucher = voucher.voucher_types.find(voucherType => (voucherType.id === reward['voucher-type'].id.toString()))
        || selectedVoucher;
      if (selectedVoucher.id) {
        const nomination = nominations[selectedVoucher.id];

        availableDenominations = this.mapDenominations(nomination);
        if (reward['voucher-denomination']) {
          selectedDenomination = nomination.find(denomination => denomination.id === reward['voucher-denomination'].id) || selectedDenomination;
        }
      }
    }

    this.setState({
      selected_type: {
        value: selectedVoucher.id,
        label: selectedVoucher.attributes.name
      },
      selected_denomination: {
        value: selectedDenomination.id,
        label: selectedDenomination.variant
      },
      autoRedeem: `${this.props.reward['auto-redeem']}`,
      voucher_denominations: availableDenominations
    });
  }

  mapDenominations(denominations) {
    if (denominations) {
      return denominations.map(denomination => ({
        value: denomination.id,
        label: denomination.variant,
      }));
    }

    return [];
  }

  handleTypeChange = (event) => {
    this.setState({
      voucher_denominations: event ? this.mapDenominations(this.props.nominations[event.value]) : [],
      selected_denomination: null,
      selected_type: event,
    });

    this.props.dispatch(actions.change("deep.admin_outlet_view.voucher_denomination_id", ''));
  };

  handleSubmit = (values) => {
    this.props.dispatch(actions.submitFields("deep.admin_outlet_view", updateOutletRest(this.props.id, values, this.props.dispatch)));
  };

  render() {
    const { selected_type, voucher_denominations, selected_denomination } = this.state;
    const { reward, voucher, delivery, features } = this.props;
    const vouchers_types = voucher.voucher_types.map(voucher_type => (
      { value: voucher_type.id, label: voucher_type.attributes.name }
    ));

    return (
      <div className="fluid">
        <Form model={OUTLET_MODEL} onSubmit={this.handleSubmit}>
          <div>
            <Row>
              <Col md={3}>
                Voucher type
              </Col>
              <Col md={9}>
                <Select model="deep.admin_outlet_view.voucher_type_id"
                        data={vouchers_types}
                        value={selected_type}
                        onChange={this.handleTypeChange}/>

                <Errors
                  show={{touched: true}}
                  className="errors"
                  model=".voucher_type_id"/>
              </Col>
            </Row>
          </div>

          <DeliveryAddressPartial model={OUTLET_MODEL} addressDetails={delivery}/>

          <Row className="mg-top-20">
            <Col md={12} className="text-right">
              <ArrowButton arrow={false}>Update</ArrowButton>
            </Col>
          </Row>

        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  outlet: state.store.outlet,
  features: state.features
});

export default connect(mapStateToProps)(OutletRewardDetails);



// WEBPACK FOOTER //
// ./src/components/admin/outlet-view/outlet-reward-details.jsx